import sliceCreator from '../../index.jsx';
import {GET_AREA_BY_ID} from '../../../constants/index.jsx';
const _getAreaByIdAction = sliceCreator('GET_AREA_BY_ID', GET_AREA_BY_ID, 'get');

const { asyncAction: getAreaByIdAction, reducer, clearData: clearGetAreaByIdAction } = _getAreaByIdAction;

export default reducer;

export {
    getAreaByIdAction,
    clearGetAreaByIdAction
}